module.exports = __webpack_public_path__ + "media/images/athletes/2868-be63fdce79f2378592cf278438ad4ede.png";